import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import contact from "../../Image/laptop-and-email-12472.svg";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
const ContactForm = (props) => {
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const sendEmail = (data) => {
    navigate("/Intermetent");
    //let formValue=data
    emailjs
      .sendForm(
        "service_90zxdlr",
        "template_r4wfipn",
        form.current,
        "2LL6D93W2vkJQjY7E"
      )
      .then(
        (result) => {
          if (result.status === 200) {
            navigate("/FinalPage");
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className=" mx-4">
      <div>
        <h4
          className="dark:text-[#758283] text-[44px] font-bold flex justify-center mt-2 [text-shadow:_4px_4px_#17A6DB]  dark:[text-shadow:_4px_4px_#30dada]"
          
        >
          <img src={contact} alt="contact" className="w-[64px] mr-2 " />
          Contact me
        </h4>
        <p className="dark:text-white text-[24px]">
          I’m interested in freelance opportunities – especially ambitious or
          large projects. However, if you have other request or question, don’t
          hesitate to use the form.
        </p>
        <div className="mt-3">
          <form
            onSubmit={handleSubmit((data) => sendEmail(data))}
            className="  "
            ref={form}
            autocomplete="off"
          >
            <input
             {...register("fullName", {
              required: true,
              maxLength: 30,
              minLength:5,
              pattern: /^[a-zA-Z ]*$/
            })}
              type="text"
              id="fullName"
              name="fullName"
              placeholder="Full Name.."
              className="placeholder:text-[#758283] text-[24px] border-[2px] border-[#17A6DB] dark:border-[#30dada]"
              autocomplete="off"
            />
            {errors?.fullName?.type === "required" && (
              <p className="error">This field is required</p>
            )}
            {errors?.fullName?.type === "maxLength" && (
              <p className="error">
               fullName cannot exceed 30 characters
              </p>
            )}
            {errors?.fullName?.type === "minLength" && (
              <p className="error">
                fullName must be 5 characters
              </p>
            )}
            {errors?.fullName?.type === "pattern" && (
              <p className="error">Alphabetical characters only</p>
            )}
            <input
              {...register("ContactDetail", {
                required: true,
                maxLength: 20,
                minLength:10,
                pattern:  /\d+/,
               
              
              })}
              type="text"
              id="lastName"
              name="ContactDetail"
              placeholder="Contact Detail.."
              className="placeholder:text-[#758283] text-[24px]  border-[2px] border-[#17A6DB] dark:border-[#30dada]"
              autocomplete="off"
            />

            {errors?.ContactDetail?.type === "required" && (
              <p className="error">    "This input is number only."</p>
            )}
            {errors?.ContactDetail?.type === "minLength" && (
              <p className="error">
               Contact Detail must be 10 characters
              </p>
            )}
             {errors?.ContactDetail?.type === "maxLength" && (
              <p className="error">
                Contact Detail cannot exceed 20 characters
              </p>
            )}
            {errors?.ContactDetail?.type === "pattern" && (
              <p className="error">Only digit number are allowed</p>
            )}
            <input
             {...register("subject", {
              required: true,
              maxLength: 30,
              minLength:5,
              pattern: /^[a-zA-Z ]*$/
            })}
              type="text"
              id="subject"
              name="subject"
              placeholder="Subject.."
              className="placeholder:text-[#758283] text-[24px] border-[2px] border-[#17A6DB] dark:border-[#30dada]"
              autocomplete="off"
            />
             {errors?.subject?.type === "required" && (
              <p className="error">This field is required</p>
            )}
            {errors?.subject?.type === "maxLength" && (
              <p className="error">
              subject cannot exceed 30 characters
              </p>
            )}
              {errors?.subject?.type === "minLength" && (
              <p className="error">
               subject must be 5 characters
              </p>
            )}
            {errors?.subject?.type === "pattern" && (
              <p className="error">Alphabetical characters only</p>
            )}
            <textarea
             {...register("Describe", {
              required: true,
              maxLength: 150,
              minLength:10,
              pattern: /^[a-zA-Z ]*$/
            })}
              name="Describe"
              id="texts"
              cols="20"
              rows="10"
              className="placeholder:text-[#758283] text-[24px]  mt-4 border-[2px] border-[#17A6DB] dark:border-[#30dada]"
              placeholder="Describe your Message here..."
            />
             {errors?.Describe?.type === "required" && (
              <p className="error">This field is required</p>
            )}
            {errors?.Describe?.type === "maxLength" && (
              <p className="error">
               Discriptions cannot exceed 150 characters
              </p>
            )}
            {errors?.Describe?.type === "minLength" && (
              <p className="error">
                Discriptions  must be  10 Words
              </p>
            )}
            {errors?.Describe?.type === "pattern" && (
              <p className="error">Alphabetical characters only</p>
            )}
            <input type="submit" className="w-[100%] bg-[#17A6DB] dark:bg-[#30dada] md:w-[70%] lg:w-[30%]" value=" Submit " />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
